import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {POLL_QUESTION, TENANT_SELECTABLE_POLL, TENANT_SELECTABLE_POLL_QUESTION} from "../../../../tenant/Config/ApiUrl";

const state = {
    called: false,
    pollQuestion:{},
    selectable: [],
}

const actions = {
    getPollQuestionDetails({commit, state}, pollQuestionId){
        commit('SET_LOADER', true)
        axiosGet(`${POLL_QUESTION}/${pollQuestionId}`).then(({ data }) =>{
            commit('POLL_QUESTION_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
    getSelectablePollQuestions({commit, state}) {
        commit('SET_CALLED', true);
        axiosGet(`${TENANT_SELECTABLE_POLL_QUESTION}`).then(({data}) => {
            commit('SKILL_POLL_QUESTION_LIST', data)
        });
    },
}

const mutations = {
    POLL_QUESTION_DETAILS_DATA(state, data){
        state.pollQuestion = data;
    },
    SKILL_POLL_QUESTION_LIST(state, data) {
        state.selectable = data;
    },
    SET_CALLED(state, data) {
        state.called = data;
    }
}

export default {
    state,
    actions,
    mutations
}
